/** Query params que abrem o painel lateral do deal em /deals. */
export function resolveOpenDealIdFromSearchParams(
  params: URLSearchParams | { get: (key: string) => string | null },
): string | null {
  return params.get('id') || params.get('highlight') || params.get('deal')
}

export function dealsPagePathForDeal(dealId: string): string {
  return `/deals?id=${encodeURIComponent(dealId)}`
}
